let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("6SkE8")).then(() => parcelRequire('gHrFG'));